import api from '~/api';
import { DownloadStatusResponse } from '../dtos/api.response';
import { PollingOptions, PollingRequest } from './polling.request';

export const getDownloadStatus = async (
  filename: string,
  accountId: string,
  userId: string
): Promise<DownloadStatusResponse> => {
  const { data } = await api.get(
    `/v1/account/${accountId}/user/${userId}/export/url?filename=${filename}&for_download=true`
  );
  return data;
};

export const pollDownload = async (
  filename: string,
  accountId: string,
  userId: string,
  options?: Partial<PollingOptions>
): Promise<string> => {
  const pollingRequest = new PollingRequest<string, DownloadStatusResponse>(
    ([filename, accountId, userId]) => getDownloadStatus(filename, accountId, userId),
    (response: DownloadStatusResponse) => response.is_ready && response.url !== null,
    { maxAttempts: 30, timeoutMs: 60000, ...options }
  );

  const finalResponse = await pollingRequest.execute(filename, accountId, userId);
  return finalResponse.url!;
};
